/* eslint-disable */
import Vue from 'vue';
import moment from 'moment';
import Trap from 'vue-focus-lock';
import rulesAPI from '../services/postData';
import common from '../services/common';
import patchData from '../services/patchData';
import axios from '../axios-config';

export const rulesMixin = {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  data() {
      return {
        postData: [],
        modalType: '',
        removeApiUrl: '',
      }
  },
  components: {
    Trap,
  },
  methods: {
    focusMyElement(refFocus) {
      document.getElementById(refFocus).focus();
    },
    /**
     * close remove property modal claim/applicant 
     * @param {*} sectionModal 
     */
    closeRemoveModalProperty(sectionModal) {
      this.$refs[sectionModal][0].hide();
    },
    
    /**
     * open driver/vehicle/incident remove modal and pass required params
     */
    openRemoveModal(modalName, apiUrl) {
      this.removeApiUrl = apiUrl;
      if (modalName === 'remove-driver-modal') {
        this.$refs.cancelBtnDrv.focus();
      }
      this.$refs[modalName].show();
    },
    /**
     * close opened remove modal
     */
    closeRemoveModal(modalName) {
      this.$refs[modalName].hide();
    },
    /**
     * This is common function to execute remove rule api
     * @param {API URL that need to call to execute rule} ruleApi 
     * @param {type mentioned vehicle/driver/incident} type 
     */
    removeRule(modalName) {
      let self = this;
      self.$store.dispatch('setStartTime');
      self.$store.dispatch('setPageActionName', 'RemoveRule');
      self.$store.dispatch('setReqValidationFlag', true);
      const formData = {
        session_id: self.$store.getters.getSessionID,
        page_name: self.$store.getters.getPageName,
        fields: common.getFormData(self.pageData),
      };
      const requestParams = {
        url: this.removeApiUrl,
        data: formData,
      };

      rulesAPI.postRule(requestParams).then((response) => {
        if (response.data.Navigate) {
          self.$refs[modalName].hide();
          self.$store.dispatch('setCurrentNav', response.data.Navigate);
          self.refreshPageData();
        } else if (response.data.fields) {
          self.$refs[modalName].hide();
          this.processRuleResponse(response);
        }
      });
      // document.getElementsByClassName("btn-secondary").focus();
       
    },
    /**
     * Common function to add vehicle/driver
     * @param {*} arr 
     * @param {*} searchItem 
     */
    addNewRule(vData, type) {
      /**
       * collect form data and prepare form post
       */
      const formData = {
        session_id: this.$store.getters.getSessionID,
        page_name: this.$store.getters.getPageName,
        fields: common.getFormData(this.pageData),
      };
      const requestParams = {
        url: vData.on_click,
        data: formData,
      };
      let currentInd = '';
      const self = this;

      rulesAPI.postRule(requestParams).then((response) => {
        this.reset_toggle_collapse();
        /**
         * update fields data from api response.
         */
        if (response.data.fields) {
          for (let v = 0; v < response.data.fields.length; v += 1) {
            this.pageData.fields.push(response.data.fields[v]);
            currentInd = response.data.fields[v].index;
            if (!isNaN(currentInd) && currentInd >= 0) {
              if (!this.pageFieldsArray[currentInd]) {
                this.pageFieldsArray.push(currentInd);
                this.pageFieldsArray[currentInd] = [];
              }
              this.pageFieldsArray[currentInd].push(response.data.fields[v]);
            }
          }
        }
        /**
         * update/add section buttons based on API response
         */
        if (response.data.section_buttons) {
          for (let btnIndex = 0; btnIndex < response.data.section_buttons.length; btnIndex += 1) {
            if (response.data.section_buttons[btnIndex].type === 'Section') {
              const remBtnArr = response.data.section_buttons[btnIndex].section.split('_');
              if (remBtnArr[0] === type) {
                if (!this.deleteLinks[remBtnArr[1]]) {
                  this.deleteLinks.push(remBtnArr[1]);
                }
                this.deleteLinks[remBtnArr[1]] = response.data.section_buttons[btnIndex];
              }
            }
          }
        }
        if (response.data.section_buttons) {
          for (let sCnt = 0; sCnt < response.data.section_buttons.length; sCnt += 1) {
            this.pageData.section_buttons.push(response.data.section_buttons[sCnt]);
          }
        }

        /* add new buttons if not availble in existing object
        or just update existing object button status */
        if (response.data.new_buttons) {
          for (let sCnt = 0; sCnt < response.data.new_buttons.length; sCnt += 1) {
            if (typeof (this.checkButtonSection(this.pageData.new_buttons, response.data.new_buttons[sCnt], 'name')) === 'undefined') {
              this.pageData.new_buttons.push(response.data.new_buttons[sCnt]);
            } else {
              for (let pSecCnt = 0; pSecCnt < this.pageData.new_buttons.length; pSecCnt += 1) {
                this.pageData.new_buttons[pSecCnt].status = response.data.new_buttons[sCnt].status;
              }
            }
          }
        }
        /*  update existing tab_button object with new tab_button status */
        /* Do not remove this code as it is required */
        if (response.data.tab_buttons) {
          for (let sCnt = 0; sCnt < response.data.tab_buttons.length; sCnt += 1) {
            for (let pSecCnt = 0; pSecCnt < this.pageData.tab_buttons.length; pSecCnt += 1) {
              if(this.pageData.tab_buttons[pSecCnt].name === response.data.tab_buttons[sCnt].name) {
                this.pageData.tab_buttons[pSecCnt].status = response.data.tab_buttons[sCnt].status;
              }  
            }
          }
        }
        /* add add buttons if not availble in existing object
        or just update existing object button status */
        if (response.data.add_buttons) {
          for (let sCnt = 0; sCnt < response.data.add_buttons.length; sCnt += 1) {
            if (typeof (this.checkButtonSection(this.pageData.add_buttons, response.data.add_buttons[sCnt], 'name')) === 'undefined') {
              this.pageData.add_buttons.push(response.data.add_buttons[sCnt]);
            } else {
              for (let pSecCnt = 0; pSecCnt < this.pageData.add_buttons.length; pSecCnt += 1) {
                this.pageData.add_buttons[pSecCnt].status = response.data.add_buttons[sCnt].status;
              }
            }
          }
        }
        /* scroll window to newly added vehicle */
        
        Vue.nextTick(function () {
          let oldEle = '';
          if (type === 'Vehicle') { 
            oldEle = document.getElementById('vehAccPanel_' + currentInd);
          } else if (type === 'Driver') {
            oldEle = document.getElementById("driverAccPanel_" + currentInd);
          }

          if (oldEle) {
            const y = oldEle.getBoundingClientRect().top + window.scrollY - 240;
            window.scroll({
              top: y,
              behavior: 'smooth',
            });
          }

          document.getElementById(self.pageFieldsArray[currentInd][0].field_name).focus();
        });
      });
    },
    addNewRuleForProperty(ApiUrl, pagenameToUpdate) {
      console.log('page update from add mortgage',pagenameToUpdate);
      // const session_id= this.$store.getters.getSessionID;
      //  const requestParamforPatch = {
      //   url: `/pages/HORateCall2Details/${session_id}`,
      //   data: common.getFormData(this.pageData),
      //  };
      //  patchData.navigationFormPatch(requestParamforPatch).then((response) =>
      //  {
      //    console.log('page update from add mortgage',pagenameToUpdate);
      //  });
      const formData = {
      session_id: this.$store.getters.getSessionID,
      page_name: this.$store.getters.getPageName,
      fields: common.getFormData(this.pageData),
     };
     const requestParams = {
      // url:"/property/rules/AddNewMortgage/QTE_PRP_MTG__Mtg", //need to make dynamic
       url:ApiUrl,
       data: formData,
     };
     
     rulesAPI.postRule(requestParams).then((response) => {
       //this.$router.replace(common.getRouteName(`/Property/homortgage/tp`));
       const timeStamp = new Date().getTime();
       this.$router.push({ path: pagenameToUpdate + '?' + timeStamp });
     });
   },

   deleteSectionRc2(section, removeModal,pagename) {
   const pageData = this.$store.state.updatePageData.pageData;
   console.log('calling delete from rule mixin for page deleteSectionRc2',pagename);
    const buttons = pageData.new_buttons || [];
    console.log('section to buttons', buttons);
    const sectionButtons = buttons.filter(button => button.name === section);
    console.log('section to sectionButtons', sectionButtons);
    const sectionButton = sectionButtons.shift(); // Since IE11 does not support .find() .
    this.$refs[removeModal][0].hide();
    axios.post(
      sectionButton.on_click, // API endpoint URL
      {
        fields: common.getFormData(this.pageData), // All of the current `pageData` fields
        page_name: this.pageData.page_name, // Current `pageData` `page_name`
        session_id: this.$store.getters.getSessionID, // Current Session ID
      },
    ).then(() => {
      // TODO: Update API to respond with which fields to remove, and remove those
      const timeStamp = new Date().getTime();
      this.$router.push({  path: pagename + '?' + timeStamp });
      // this.$router.go(commonService.getRouteName(`/Property/${this.pageData.page_name}/tp`));
    }).catch((error) => {
      // TODO: Use response (data or http code) to evaluate error
      window.console.warn('An error occurred while requesting a section button post:', error);
      gtag('event', 'exception', {
        description: 'Error requesting section button quote',
        fatal: false, // set to true if the error is fatal
      });
    });
  },
    /**
     * Add/Delete polk vehicle/driver in quote using common function
     * @param {*} pData 
     */
    updatePolkData(pData, type) {
      let pageName = '';
      const formData = {
        session_id: this.$store.getters.getSessionID,
        page_name: this.$store.getters.getPageName,
        fields: common.getFormData(this.pageData),
      };
      if (type === 'vehicle') {
        pageName = 'Vehicle';
      } else {
        pageName = 'Driver';
      }
      
      const requestParams = {
        url: pData.on_click,
        data: formData,
      };
      if (pData.status === 'Included') {
        if (type === 'vehicle') {
          this.openRemoveModal('remove-vehicle-modal', pData.on_click);
        } else if (type === 'driver') {
          this.openRemoveModal('remove-driver-modal', pData.on_click);
        }  
      } else {
        // set start time and page action to track load time
        this.$store.dispatch('setStartTime');
        this.$store.dispatch('setPageActionName', 'PolkAdd');
        this.$store.dispatch('setReqValidationFlag', true);
        rulesAPI.postRule(requestParams).then((response) => {
          if (response.data.Navigate) {
            // log API response time through application into GA tool
            common.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'PolkAddAPI', pageName);
            this.$store.dispatch('setCurrentNav', response.data.Navigate);
            const routeName = common.getRouteName(response.data.Navigate);
            const timeStamp = new Date().getTime();
            this.$router.push({ path: routeName + '?' + timeStamp });
          }
        });
      }
    },
    checkElement(arr, searchItem) {
      for(var i=0; i<arr.length; i++) {
          if (arr[i].field_name === searchItem) return true;
      }
    },
    checkButtonSection(arr, searchItem, chkType, index) {
      for(var i=0; i<arr.length; i++) {
        if(chkType === 'section') {
          if (arr[i].section === searchItem.section) return true;
        } else if(chkType === 'type_name') {
          if (arr[i].type === searchItem.type && arr[i].name === searchItem.name) return true;
        } else if(chkType === 'name') {
          if (arr[i].name === searchItem.name) return true;
        }  
      }
    },
    sendPost(url) {
      
      this.updatePostData();

      const formData = {
        session_id: "",
        page_name: this.pageData.page_name,
        fields: common.getFormData(this.pageData),
      };

      let requestParams = {
        url: url,
        data: formData
      };

      /**
       * Compare the original route to the route the promise completes on so
       * that we can short-circuit requests that return after the user has
       * moved on to another route. This avoids race conditions with previous
       * data showing up after the route has changed.
       */
      const originalRoute = this.$router.currentRoute.name;

      rulesAPI.postRule(requestParams).then((response) => {
        const newRoute = this.$router.currentRoute.name;

        if (originalRoute !== newRoute) {
          window.console.warn('Short-circuit the request since the route has changed.');
          return;
        }

        this.processRuleResponse(response);
      });

    },
    /*TODO: need to create generic logic for Auto & home bundle*/
    sendBundlePost(url) {
      
      this.updateBundlePostData();

      const formData = {
        session_id: JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId,
        page_name: this.homePageData.page_name,
        fields: common.getFormData(this.homePageData),
      };

      let requestParams = {
        url: url,
        data: formData
      };

      /**
       * Compare the original route to the route the promise completes on so
       * that we can short-circuit requests that return after the user has
       * moved on to another route. This avoids race conditions with previous
       * data showing up after the route has changed.
       */
      const originalRoute = this.$router.currentRoute.name;

      rulesAPI.postRule(requestParams).then((response) => {
        const newRoute = this.$router.currentRoute.name;

        if (originalRoute !== newRoute) {
          window.console.warn('Short-circuit the request since the route has changed.');
          return;
        }

        this.processBundleRuleResponse(response);
      });

    },
    updatePostData() {

      this.postData = [];

      for(let arrayCnt = 0; arrayCnt < this.pageData.fields.length; arrayCnt++ ) {
        let tempPostData = {
          field_name: this.pageData.fields[arrayCnt].field_name,
          field_value: this.pageData.fields[arrayCnt].field_value,
          field_type: this.pageData.fields[arrayCnt].field_type,
        }
        this.postData.push(tempPostData);
      }
    },
    /*TODO: need to create generic logic for Auto & home bundle*/
    updateBundlePostData() {

      this.postData = [];

      for(let arrayCnt = 0; arrayCnt < this.homePageData.fields.length; arrayCnt++ ) {
        let tempPostData = {
          field_name: this.homePageData.fields[arrayCnt].field_name,
          field_value: this.homePageData.fields[arrayCnt].field_value,
          field_type: this.homePageData.fields[arrayCnt].field_type,
        }
        this.postData.push(tempPostData);
      }
    },
    processRuleResponse(response) {
      let incidentArr = [];
      let incSubStatus = false;
      if (response.data.section_buttons) {
       
        for (let sCnt = 0; sCnt < response.data.section_buttons.length; sCnt += 1) {
          
          const newSectionChk = this.pageData.section_buttons.find(function (obj) { return obj.section === response.data.section_buttons[sCnt].section; });  
          if (typeof newSectionChk != 'undefined') {
            for(let pSecCnt = 0; pSecCnt < this.pageData.section_buttons.length; pSecCnt += 1) {
              if(this.pageData.section_buttons[pSecCnt].section === response.data.section_buttons[sCnt].section) {
                this.pageData.section_buttons[pSecCnt].status = response.data.section_buttons[sCnt].status;
              }
            }
          } else {
            this.pageData.section_buttons.push(response.data.section_buttons[sCnt])
          }  
        }
      }
      /* check add_button modification in rule response */
      if (response.data.add_buttons) {
        for (let sCnt = 0; sCnt < response.data.add_buttons.length; sCnt += 1) {
          if (typeof(this.checkButtonSection(this.pageData.add_buttons, response.data.add_buttons[sCnt], 'section')) === "undefined") {
            this.pageData.add_buttons.push(response.data.add_buttons[sCnt])
          } else {
            for (let pSecCnt = 0; pSecCnt < this.pageData.add_buttons.length; pSecCnt += 1) {
              if(this.pageData.add_buttons[pSecCnt].name === 'AddIncident' && this.pageData.add_buttons[pSecCnt].section === response.data.add_buttons[sCnt].section) {
                this.pageData.add_buttons[pSecCnt].status = response.data.add_buttons[sCnt].status;
              }
            }
          }
          if (typeof(this.checkButtonSection(this.pageData.add_buttons, response.data.add_buttons[sCnt], 'section')) === "undefined") {
            this.pageData.add_buttons.push(response.data.add_buttons[sCnt])
          } else {
            for (let pSecCnt = 0; pSecCnt < this.pageData.add_buttons.length; pSecCnt += 1) {
              if(this.pageData.add_buttons[pSecCnt].name === 'AddIncident' && this.pageData.add_buttons[pSecCnt].section === response.data.add_buttons[sCnt].section) {
                this.pageData.add_buttons[pSecCnt].status = response.data.add_buttons[sCnt].status;
              }
            }
          }
          
        }
      }

      /* check if new_button node need to updated */
      if (response.data.new_buttons) {
        for (let sCnt = 0; sCnt < response.data.new_buttons.length; sCnt += 1) {
          if (typeof(this.checkButtonSection(this.pageData.new_buttons, response.data.new_buttons[sCnt], 'type_name')) === "undefined") {
            this.pageData.new_buttons.push(response.data.new_buttons[sCnt])
          } else {
            for (let pSecCnt = 0; pSecCnt < this.pageData.new_buttons.length; pSecCnt += 1) {
              if(this.pageData.new_buttons[pSecCnt].name === response.data.new_buttons[sCnt].name && this.pageData.new_buttons[pSecCnt].type === response.data.new_buttons[sCnt].type) {
                this.pageData.new_buttons[pSecCnt].label = response.data.new_buttons[sCnt].label;
                this.pageData.new_buttons[pSecCnt].status = response.data.new_buttons[sCnt].status;
              }
            }
          }
        }
      }
      if (response.data.tab_buttons && response.data.tab_buttons.length) {
        this.pageData.tab_buttons = response.data.tab_buttons;
      }
      if (response.data.fields) {
        for(let arrayCntResp = 0; arrayCntResp < response.data.fields.length; arrayCntResp++ ) {
          let indexVal = response.data.fields[arrayCntResp].index;
          let subIndexVal = response.data.fields[arrayCntResp].sub_index;

          if (response.data.fields[arrayCntResp].field_type === 'date_mmyyyy') {
            response.data.fields[arrayCntResp].field_value = moment(response.data.fields[arrayCntResp].field_value, 'MMYYYY').format('MM/YYYY');
          }

          if (response.data.fields[arrayCntResp].field_type === 'date_long' || response.data.fields[arrayCntResp].field_type === 'date_short' || response.data.fields[arrayCntResp].field_type === 'date_long_pii') {
            response.data.fields[arrayCntResp].field_value = moment(response.data.fields[arrayCntResp].field_value, 'YYYYMMDD').format('MM/DD/YYYY');
          }
          // make field value empty for check box if its false
          if (response.data.fields[arrayCntResp].field_type === 'checkbox' && response.data.fields[arrayCntResp].field_value === "false") {
            response.data.fields[arrayCntResp].field_value = '';
          }
          /** check if incoming field is related to annual mileage mean number_medium, if yes then dispatched annual mileage calculation to update store value */
          if (response.data.fields[arrayCntResp].field_type === 'number_medium') {
            this.$store.dispatch('annualCalc', { index: indexVal, value: response.data.fields[arrayCntResp].field_value });
          }

          /** check if incoming field is related to Miles means numberterm_miles, if yes then dispatched annual mileage calculation to update store value */
          if (response.data.fields[arrayCntResp].field_type === 'numberterm_miles') {
            this.$store.dispatch('updateMiles', { index: indexVal, value: response.data.fields[arrayCntResp].field_value });
          }
          /** check if incoming field is related to Days means numberterm_days, if yes then dispatched annual mileage calculation to update store value */
          if (response.data.fields[arrayCntResp].field_type === 'numberterm_days') {
            this.$store.dispatch('updateDays', { index: indexVal, value: response.data.fields[arrayCntResp].field_value });
          }
          
          //updateDays

          /* check if field exists in this.pageData, if not then add same field*/
          if (typeof(this.checkElement(this.pageData.fields, response.data.fields[arrayCntResp].field_name)) === "undefined") {
            this.pageData.fields.push(response.data.fields[arrayCntResp]);
          }
          /******************* */
          for(let vCnt = 0; vCnt < this.pageData.fields.length; vCnt += 1) {
            if(this.pageData.fields[vCnt].field_name === response.data.fields[arrayCntResp].field_name) {
              for(let key in response.data.fields[arrayCntResp]) {
                this.pageData.fields[vCnt][key] = response.data.fields[arrayCntResp][key];
              }
              break;
            }
          }
          
          if(subIndexVal !== null) {
            if(!this.incidentFieldArray[indexVal]) {
              //this.incidentFieldArray.push(indexVal);
              this.incidentFieldArray[indexVal] = [];
            }
            if(!this.incidentFieldArray[indexVal][subIndexVal]) {
              this.incidentFieldArray[indexVal].push(subIndexVal);
              this.incidentFieldArray[indexVal][subIndexVal] = [];
            }

            /* check if field exists in this.pageData, if not then add same field*/
            if (typeof(this.checkElement(this.incidentFieldArray[indexVal][subIndexVal], response.data.fields[arrayCntResp].field_name)) === "undefined") {
              this.incidentFieldArray[indexVal][subIndexVal].push(response.data.fields[arrayCntResp]);
            }
            /******************* */
          }
        }
        this.pageData.fields.sort(function(a, b) {
          return a.display_order - b.display_order;
        });
      }

      if (response.data.carrier_payment_information_section && response.data.carrier_payment_information_section.length >= 1) {
        this.carrierPaymentInformationSection = response.data.carrier_payment_information_section;
      }

      this.$forceUpdate();

      /**
       * Remove validation error messages from fields that are now disabled. This needs to be done here
       * manually because validation is currently only done on submit which can leave a validation error
       * message on a field that was enabled + invalid but is now disabled (and disabled is always valid).
       */
      const fields = (response.data && Array.isArray(response.data.fields) ? response.data.fields : []);

      fields.forEach(field => {
        if (field.is_enabled === false) {
          this.$validator.errors.remove(field.field_name);
        }
      });
    },
    
    /*TODO: need to create generic logic for Auto & home bundle*/
    processBundleRuleResponse(response) {
      let incidentArr = [];
      let incSubStatus = false;
      if (response.data.section_buttons) {
       
        for (let sCnt = 0; sCnt < response.data.section_buttons.length; sCnt += 1) {
          
          const newSectionChk = this.homePageData.section_buttons.find(function (obj) { return obj.section === response.data.section_buttons[sCnt].section; });  
          if (typeof newSectionChk != 'undefined') {
            for(let pSecCnt = 0; pSecCnt < this.homePageData.section_buttons.length; pSecCnt += 1) {
              if(this.homePageData.section_buttons[pSecCnt].section === response.data.section_buttons[sCnt].section) {
                this.homePageData.section_buttons[pSecCnt].status = response.data.section_buttons[sCnt].status;
              }
            }
          } else {
            this.homePageData.section_buttons.push(response.data.section_buttons[sCnt])
          }  
        }
      }
      /* check add_button modification in rule response */
      if (response.data.add_buttons) {
        for (let sCnt = 0; sCnt < response.data.add_buttons.length; sCnt += 1) {
          if (typeof(this.checkButtonSection(this.homePageData.add_buttons, response.data.add_buttons[sCnt], 'section')) === "undefined") {
            this.homePageData.add_buttons.push(response.data.add_buttons[sCnt])
          } else {
            for (let pSecCnt = 0; pSecCnt < this.homePageData.add_buttons.length; pSecCnt += 1) {
              if(this.homePageData.add_buttons[pSecCnt].name === 'AddIncident' && this.homePageData.add_buttons[pSecCnt].section === response.data.add_buttons[sCnt].section) {
                this.homePageData.add_buttons[pSecCnt].status = response.data.add_buttons[sCnt].status;
              }
            }
          }
          if (typeof(this.checkButtonSection(this.homePageData.add_buttons, response.data.add_buttons[sCnt], 'section')) === "undefined") {
            this.homePageData.add_buttons.push(response.data.add_buttons[sCnt])
          } else {
            for (let pSecCnt = 0; pSecCnt < this.homePageData.add_buttons.length; pSecCnt += 1) {
              if(this.homePageData.add_buttons[pSecCnt].name === 'AddIncident' && this.homePageData.add_buttons[pSecCnt].section === response.data.add_buttons[sCnt].section) {
                this.homePageData.add_buttons[pSecCnt].status = response.data.add_buttons[sCnt].status;
              }
            }
          }
          
        }
      }

      /* check if new_button node need to updated */
      if (response.data.new_buttons) {
        for (let sCnt = 0; sCnt < response.data.new_buttons.length; sCnt += 1) {
          if (typeof(this.checkButtonSection(this.homePageData.new_buttons, response.data.new_buttons[sCnt], 'type_name')) === "undefined") {
            this.homePageData.new_buttons.push(response.data.new_buttons[sCnt])
          } else {
            for (let pSecCnt = 0; pSecCnt < this.homePageData.new_buttons.length; pSecCnt += 1) {
              if(this.homePageData.new_buttons[pSecCnt].name === response.data.new_buttons[sCnt].name && this.homePageData.new_buttons[pSecCnt].type === response.data.new_buttons[sCnt].type) {
                this.homePageData.new_buttons[pSecCnt].label = response.data.new_buttons[sCnt].label;
                this.homePageData.new_buttons[pSecCnt].status = response.data.new_buttons[sCnt].status;
              }
            }
          }
        }
      }
      if (response.data.tab_buttons && response.data.tab_buttons.length) {
        this.homePageData.tab_buttons = response.data.tab_buttons;
      }
      if (response.data.fields) {
        for(let arrayCntResp = 0; arrayCntResp < response.data.fields.length; arrayCntResp++ ) {
          let indexVal = response.data.fields[arrayCntResp].index;
          let subIndexVal = response.data.fields[arrayCntResp].sub_index;

          if (response.data.fields[arrayCntResp].field_type === 'date_mmyyyy') {
            response.data.fields[arrayCntResp].field_value = moment(response.data.fields[arrayCntResp].field_value, 'MMYYYY').format('MM/YYYY');
          }

          if (response.data.fields[arrayCntResp].field_type === 'date_long' || response.data.fields[arrayCntResp].field_type === 'date_short' || response.data.fields[arrayCntResp].field_type === 'date_long_pii') {
            response.data.fields[arrayCntResp].field_value = moment(response.data.fields[arrayCntResp].field_value, 'YYYYMMDD').format('MM/DD/YYYY');
          }
          // make field value empty for check box if its false
          if (response.data.fields[arrayCntResp].field_type === 'checkbox' && response.data.fields[arrayCntResp].field_value === "false") {
            response.data.fields[arrayCntResp].field_value = '';
          }
          /** check if incoming field is related to annual mileage mean number_medium, if yes then dispatched annual mileage calculation to update store value */
          if (response.data.fields[arrayCntResp].field_type === 'number_medium') {
            this.$store.dispatch('annualCalc', { index: indexVal, value: response.data.fields[arrayCntResp].field_value });
          }

          /** check if incoming field is related to Miles means numberterm_miles, if yes then dispatched annual mileage calculation to update store value */
          if (response.data.fields[arrayCntResp].field_type === 'numberterm_miles') {
            this.$store.dispatch('updateMiles', { index: indexVal, value: response.data.fields[arrayCntResp].field_value });
          }
          /** check if incoming field is related to Days means numberterm_days, if yes then dispatched annual mileage calculation to update store value */
          if (response.data.fields[arrayCntResp].field_type === 'numberterm_days') {
            this.$store.dispatch('updateDays', { index: indexVal, value: response.data.fields[arrayCntResp].field_value });
          }
          
          //updateDays

          /* check if field exists in this.homePageData, if not then add same field*/
          if (typeof(this.checkElement(this.homePageData.fields, response.data.fields[arrayCntResp].field_name)) === "undefined") {
            this.homePageData.fields.push(response.data.fields[arrayCntResp]);
          }
          /******************* */
          for(let vCnt = 0; vCnt < this.homePageData.fields.length; vCnt += 1) {
            if(this.homePageData.fields[vCnt].field_name === response.data.fields[arrayCntResp].field_name) {
              for(let key in response.data.fields[arrayCntResp]) {
                this.homePageData.fields[vCnt][key] = response.data.fields[arrayCntResp][key];
              }
              break;
            }
          }
          
          if(subIndexVal !== null) {
            if(!this.incidentFieldArray[indexVal]) {
              //this.incidentFieldArray.push(indexVal);
              this.incidentFieldArray[indexVal] = [];
            }
            if(!this.incidentFieldArray[indexVal][subIndexVal]) {
              this.incidentFieldArray[indexVal].push(subIndexVal);
              this.incidentFieldArray[indexVal][subIndexVal] = [];
            }

            /* check if field exists in this.homePageData, if not then add same field*/
            if (typeof(this.checkElement(this.incidentFieldArray[indexVal][subIndexVal], response.data.fields[arrayCntResp].field_name)) === "undefined") {
              this.incidentFieldArray[indexVal][subIndexVal].push(response.data.fields[arrayCntResp]);
            }
            /******************* */
          }
        }
        this.homePageData.fields.sort(function(a, b) {
          return a.display_order - b.display_order;
        });
      }

      if (response.data.carrier_payment_information_section && response.data.carrier_payment_information_section.length >= 1) {
        this.homeCarrierPaymentInformationSection = response.data.carrier_payment_information_section;
      }

      this.$forceUpdate();

      /**
       * Remove validation error messages from fields that are now disabled. This needs to be done here
       * manually because validation is currently only done on submit which can leave a validation error
       * message on a field that was enabled + invalid but is now disabled (and disabled is always valid).
       */
      const fields = (response.data && Array.isArray(response.data.fields) ? response.data.fields : []);

      fields.forEach(field => {
        if (field.is_enabled === false) {
          this.$validator.errors.remove(field.field_name);
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/rulesMixin.js